import { css } from '@emotion/react';
import { colors } from '../../styles/colorPalette';

// 배경 이미지 import
import economicStructureBg from '../../images/경제구조.png';
import socialWelfareBg from '../../images/사회복지.png';
import populationBg from '../../images/인구특성.png';
import financeTaxBg from '../../images/재정세금.png';

export const container = css`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 1370px;
    min-height: calc(100vh - 130px);
    margin: auto;
    padding: 15px 0px;
`;
export const bannerContainer = css`
    display: flex;
    justify-content: space-between;
    padding-top: 25px;
`;
export const bannerTextContainer = css`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;
export const title = css`
    display: flex;
    flex-direction: column;
    justify-content: space-around;

    font-size: 35px;
    font-weight: 500;

    letter-spacing: 3.5px;
    line-height: 150%;
`;

export const mainText = css`
    font-size: 45px;
    font-weight: 500;
    letter-spacing: 3.5px;
    margin-top: 50px;
`;

export const subText = css`
    font-size: 18px;
    font-weight: 400;
    line-height: 35px;
    margin-top: 20px;
`;

export const mapLinkImgContainer = css`
    padding-top: 20px;
    align-self: flex-start;
    font-size: 20px;
`;

export const linkImgBox = css`
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 20px 100px;
`;

export const linkImg = css`
    width: 250px;
    cursor: pointer;
`;

// CommonButton 스타일들
export const categoryButtonBase = css`
    width: 250px;
    height: 250px;
    background: #2c3e50;
    color: white;
    border-radius: 12px;
    margin: 10px;
    display: flex;
    flex-direction: column;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    overflow: hidden;
    position: relative;

    &:hover {
        transform: scale(1.05);
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);

        .icon-area {
            filter: grayscale(0%);
        }

        svg {
            opacity: 0;
        }
    }

    /* 아이콘 영역 (상단 2/3) */
    .icon-area {
        flex: 4;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        width: 100%;
        filter: grayscale(100%);
        transition: filter 0.3s ease;
    }

    /* 텍스트 영역 (하단 1/3) */
    .text-area {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #7f8c8d;
        font-weight: 600;
        font-size: 16px;
        width: 100%;
    }

    svg {
        font-size: 3.5rem;
        color: white;
        background: rgba(128, 128, 128, 0.8);
        border-radius: 50%;
        padding: 20px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
        transition: all 0.3s ease;
    }
`;

export const economicStructureButton = css`
    ${categoryButtonBase}
    .icon-area {
        background: url(${economicStructureBg}) no-repeat center center;
        background-size: cover;
    }
`;

export const socialWelfareButton = css`
    ${categoryButtonBase}
    .icon-area {
        background: url(${socialWelfareBg}) no-repeat center center;
        background-size: cover;
    }
`;

export const populationButton = css`
    ${categoryButtonBase}
    .icon-area {
        background: url(${populationBg}) no-repeat center center;
        background-size: cover;
    }
`;

export const financeTaxButton = css`
    ${categoryButtonBase}
    .icon-area {
        background: url(${financeTaxBg}) no-repeat center center;
        background-size: cover;
    }
`;

export const buttonContainer = css`
    display: flex;
    justify-content: flex-start;
    width: 100%;
    padding: 20px 0px;
    gap: 15px;

    /* 버튼 간격과 스타일 개선 */
    button {
        border-radius: 8px !important;
        font-weight: 600 !important;
        transition: all 0.3s ease !important;

        &:hover {
            transform: translateY(-2px) !important;
        }
    }
`;

// 드롭다운 관련 스타일 추가
export const dropdownContainer = css`
    position: relative;
    display: inline-block;
`;

export const dropdownMenu = css`
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: #fdfdfd;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    min-width: 140px;
    margin-top: 2px;
`;

export const dropdownItem = css`
    padding: 8px 12px;
    color: #002755;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: #f5f5f5;
    }

    &:first-of-type {
        border-radius: 4px 4px 0 0;
    }

    &:last-of-type {
        border-radius: 0 0 4px 4px;
    }
`;
